











































































































































































































import { Component, Vue } from 'vue-property-decorator';
import contestService from '../../../modules/contests/services/ContestService'
@Component({
    components: {
    },
})
export default class ContestDetail extends Vue {
    private get contestId() {
        return this.$route.params.id;
    }
    private selectedEntryNumber = 1;
    private get selectedEntryLineup() {
        if (this.contestData) {
            // @ts-ignore
            return this.contestData.entries[this.selectedEntryNumber].lineup || null
        }
    }

    private contestData = null;
    private async mounted() {
        this.contestData = await contestService.fetchContestDetails(this.contestId)

    }
}
